import type * as api from '@gitbook/api-client';
import type { NavigationMergeRulesSideSheet } from '@gitbook/app-navigation';
import { DialogRoot } from '@gitbook/spine-react';

import { MergeRulesDialog } from '../../../Components';
import { useSideSheetNavigation } from '../../../navigation';

/**
 * Dialog to configure the merge rule for a space.
 */
export function SpaceMergeRulesDialog(props: { space: api.Space }) {
    const { space } = props;

    const { opened, close } = useSideSheetNavigation<NavigationMergeRulesSideSheet>('merge-rule');

    return (
        <DialogRoot isOpen={opened} onOpenChange={close}>
            <MergeRulesDialog space={space} />
        </DialogRoot>
    );
}
